import Highcharts from "highcharts";
const mapData = require("@highcharts/map-collection/countries/us/custom/us-all-territories.topo.json");
 
export const BAR_CHART: Highcharts.Options = {
  chart: {
    type: "bar",
    height: 150,
  },

  title: {
    text: "",
    align: "left",
  },

  xAxis: {
    categories: ["Pending Cases", "Investigated Cases"],
    title: {
      text: null,
    },
    gridLineWidth: 0,
    lineWidth: 1,
  },

  yAxis: {
    min: 0,
    title: {
      text: "",
    },
    labels: {
      enabled: false,
    },
    gridLineWidth: 1,
  },

  plotOptions: {
    bar: {
      borderRadius: "0",
      dataLabels: {
        enabled: false,
      },
      groupPadding: 0.1,
    },
  },

  colors: ["rgb(124, 181, 236)"],

  credits: {
    enabled: false,
  },

  legend: {
    enabled: false,
  },

  accessibility: {
    enabled: false,
  },
};
export const BAR_CHART_PRIOR_AUTHS: Highcharts.Options = {
  chart: {
    type: "bar",
    height: 150,
  },

  title: {
    text: "",
    align: "left",
  },

  xAxis: {
    categories: ["Submitted to Plan", "Pending Transcription"," ","Approved","Denied"],
    title: {
      text: null,
    },
    gridLineWidth: 0,
    lineWidth: 1,
  },

  yAxis: {
    min: 0,
    title: {
      text: "",
    },
    labels: {
      enabled: false,
    },
    gridLineWidth: 1,
  },

  plotOptions: {
    bar: {
      borderRadius: "0",
      dataLabels: {
        enabled: false,
      },
      groupPadding: 0.1,
    },
  },

  colors: ["rgb(124, 181, 236)"],

  credits: {
    enabled: false,
  },

  legend: {
    enabled: false,
  },

  accessibility: {
    enabled: false,
  },
};
export const BAR_CHART_STIMROUTER: Highcharts.Options = {
  // chart: {
  //   type: "bar",
  //   height: 150,
  // },

  // title: {
  //   text: "",
  //   align: "left",
  // },

  // xAxis: {
  //   categories: ["Stimrouter"],
  //   title: {
  //     text: null,
  //   },
  //   gridLineWidth: 0,
  //   lineWidth: 1,
  // },

  // yAxis: {
  //   min: 0,
  //   title: {
  //     text: "",
  //   },
  //   max:50,
  //   labels: {
  //     enabled: false,
  //   },
  //   gridLineWidth: 1,
  // },

  // plotOptions: {
  //   bar: {
  //     borderRadius: "0",
  //     dataLabels: {
  //       enabled: false,
  //     },
  //     groupPadding: 0.1,
  //   },
  // },

  // colors: ["rgb(124, 181, 236)"],

  // credits: {
  //   enabled: false,
  // },
  // legend: {
  //   enabled: false,
  //   // layout: 'vertical',
  //   // align: 'right',
  //   // verticalAlign: 'top',
  //   // x: -40,
  //   // y: 80,
  //   // floating: true,
  //   // borderWidth: 1,
  //   // backgroundColor:
  //   //    '#FFFFFF',
  //   // shadow: true
  // },
  // accessibility: {
  //   enabled: false,
  // },
  chart: {
    type: 'bar',
    height: 150,
  },
  title: {
    text: '',
  },
  xAxis: {
    categories:["Stimrouter"],
    title: {
      text: null,
    },
  },
  yAxis: {
    min: 0,
    title: {
      text: null,
      align: 'high',
    },
    labels: {
      overflow: 'justify',
    },
  },
  plotOptions: {
    bar: {
      dataLabels: {
        enabled: false,
      },
    },
  },
  colors: ["rgb(124, 181, 236)"],
  credits: {
    enabled: false,
  },
  series: [
    {
      name: 'Value',
      data: [954, 346, 152],
      type: 'bar',
    },
  ],
  legend:{
    enabled:false
  }
};

export const LINE_CHART: Highcharts.Options = {
  title: {
    text: "",
    align: "left",
  },
  chart:{
    type:'area'
  },
  yAxis: {
    title: {
      text: "",
    },
    accessibility:{
        rangeDescription:"Range:  22 Jan to 13 Feb"
    }
  },
  tooltip: {
    shared: false,
    split: true,
    // shared: true,
    // useHTML: true,
    // formatter: function () {
    //   let tooltipContent = `<b>${this.x}</b><br>`;
      
    //   // Loop through all the points in the tooltip and display their values
    //   this.points?.forEach(point => {
    //     tooltipContent += `${point.series.name}: ${point.y}<br>`;
    //   });

    //   // Check if the values of the two series are the same at this x value
    //   const points = this.points;
    //   if (points && points.length > 0) {
    //     if (points[0].y === points[1].y) {
    //       tooltipContent += `<b>Both lines have the same value: ${points[0].y}</b><br>`;
    //     }
    //   }

    //   return tooltipContent;
    // },
    // xDateFormat: '%A, %b %e, %Y', // e.g., "Friday, Dec 13, 2024",
},
xAxis: {
  // minRange: 2,
//     type: 'datetime',
//     labels: {
//         formatter: function () {
//             // Use Highcharts.dateFormat to customize the date format
//             return Highcharts.dateFormat('%e %b ',Number(this.value)); // e.g., "13 Dec 2024"
//         }
//     }
},
// tooltip: {
//     xDateFormat: '%A, %b %e, %Y' // e.g., "Friday, Dec 13, 2024"
// },
  credits: {
    enabled: false
  },
  legend: {
    layout: 'horizontal',
    align: "center",
    verticalAlign: 'bottom',
  },
  plotOptions: {
    series: {
      label: {
        connectorAllowed: false,
      },
      connectNulls: true,
      pointStart: 0,
    },
  },
  series: [],
  responsive: {
    rules: [{
      condition: {
        maxWidth: 500,
      },
      chartOptions: {
        legend: {
          layout: "horizontal",
          align: "center",
          verticalAlign: "bottom",
        },
      },
    }],
  },
  accessibility: {
    enabled: false,
  },
  
};

export const PIE_CHART_OPTIONS: Highcharts.Options = {
  chart: {
    type: "pie",
  },
  title: {
    text: "",
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    valueSuffix: "",
    format: "<b>{point.name}: {point.percentage:.1f}%</b>",
    style: {
      fontSize: "0.7em", // Adjust the tooltip font size here
      fontWeight: "normal",
    },
  },
  // plotOptions: {
  //   pie: {
  //     allowPointSelect: true,
  //     cursor: "pointer",
  //     //showInLegend: true,
  //     dataLabels: {
  //       enabled: false,
  //       format: "<b>{point.name}:  {point.percentage:.1f}%</b>",
  //       style: {
  //         fontWeight: "normal",
  //         textOverflow: "clip",
  //       },
  //       connectorPadding: 1,
  //       connectorWidth: 1,
  //       distance: 20,
  //     },
  //   },
  // },
  plotOptions: {
    series: {
        allowPointSelect: true,
        showInLegend:false,
        cursor: 'pointer',
        dataLabels: [{
            enabled: true,
            format: "<b>{point.title}: {point.percentage:.1f}%</b>",

            // distance: 20
        },
         {
            enabled: true,
            // distance: -40,
          format: "<b>{point.title}: {point.percentage:.1f}%</b>",
            //format: "<b>{point.percentage:.1f}%</b>",

            style: {
                fontSize: '1.2em',
                textOutline: 'none',
                opacity: 0.7
            },
            filter: {
                operator: '<',
                property: 'percentage',
                value: 0.00001
            }
        }
      ]
    }
  },
  series: [
    {
      type: "pie",
      name: "Percentage",
      // colorByPoint: true,
      data: [
        {
          name: "",
          y: 597,
          color:"#7cb5ec"
        },
        {
          name: "MOBILE",
          y: 10,
          color:"#434348"
        },
        {
          name: "JUBILLE",
          y: 10,
          color:"#90ed7d"
        },
        {
          name: "PERX1",
          y: 10,
          color:"#f7a35c"
        },
        {
          name: "ABC TEST",
          y: 8,
          color:"#8085e9"
        },
        {
          name: "PAPER",
          y: 7,
          color:"#f15c80"
        },
        {
          name: "BLUE CROSS",
          y: 6,
          color:"#e4d354"
        },
        {
          name: "MELVIN SHAW",
          y: 5,
          color:"#2b908f"
        },
        {
          name: "MED-INS1",
          y: 5,
          color:"#f45b5b"
        },
        {
          name: "Hea CS",
          y: 5,
          color:"#91e8e1"
        },
      ],
    },
  ],
  accessibility: {
    enabled: false,
  },
};

export const MAP_CHART: Highcharts.Options = {
  chart: {
    map: mapData,
  },

  title: {
    text: "",
  },

  subtitle: {
    text: "",
  },
  credits: {
    enabled: false,
  },
  mapNavigation: {
    enabled: false,
    buttonOptions: {
      verticalAlign: "bottom",
    },
  },

  colorAxis: {
    min: 0,
    max: 30,
    //type: 'logarithmic',
    minColor: "#EEEEFF",
    maxColor: "#000022",
    stops: [
      [0, "#EFEFFF"],
      [0.67, "#4444FF"],
      [1, "#000022"],
    ],
  },
  accessibility: {
    enabled: false,
  },
};
